import { Box, Button, Grid, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import aceites from "../assets/images/aceite2.jpg";
import relajante from "../assets/images/relax.jpg";
import manos from "../assets/images/4manos.jpeg";
import thai from "../assets/images/thai3b.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

export const Tratamientos = () => {
  const treatments = [
    {
      title: "Masaje Relajante Oriental",
      desc: "Alivia tensiones acumuladas y estrés diario con técnicas suaves de relajación.",
      img: relajante,
      alt: "Masaje relajante oriental en Barcelona",
      prices: [
        { duration: "60 min", price: "35 €" },
        { duration: "30 min", price: "25 €" },
      ],
    },
    {
      title: "Masaje a 4 Manos",
      desc: "Exclusivo masaje sincronizado por dos masajistas para una desconexión total.",
      img: manos,
      alt: "Masaje exclusivo a cuatro manos en Barcelona",
      prices: [
        { duration: "60 min", price: "70 €" },
        { duration: "30 min", price: "50 €" },
      ],
    },
    {
      title: "Aceites Esenciales",
      desc: "Aromaterapia y aceites naturales para nutrir la piel y renovar energías.",
      img: aceites,
      alt: "Masaje con aceites esenciales aromáticos y relajantes",
      prices: [
        { duration: "60 min", price: "40 €" },
        { duration: "30 min", price: "30 €" },
      ],
    },
    {
      title: "Masaje Tradicional Thai / Chino",
      desc: "Técnicas milenarias de presión y estiramientos para restaurar tu bienestar.",
      img: thai,
      alt: "Masaje tradicional chino y thai en Barcelona",
      prices: [
        { duration: "60 min", price: "60 €" },
        { duration: "30 min", price: "40 €" },
      ],
    },
  ];

  return (
    <section id="tratamientos">
      <Container sx={{ py: { xs: 5, md: 7 } }}>
        <Box sx={{ maxWidth: "700px", mx: "auto", textAlign: "center", mb: 4.5 }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 0.6,
              borderRadius: "30px",
              backgroundColor: "rgba(212, 175, 55, 0.1)",
              border: "1px solid rgba(212, 175, 55, 0.25)",
              color: "#9E7736",
              fontSize: "0.75rem",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              mb: 2,
            }}
          >
            <span>✦</span> Carta de Masajes
          </Box>
          <Typography
            variant="h2"
            sx={{
              mb: 1.5,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              color: "#1C1612",
              fontWeight: 700,
              fontSize: { xs: "1.85rem", md: "2.35rem" },
              letterSpacing: "-0.02em",
            }}
          >
            Nuestros Tratamientos en Barcelona
          </Typography>
          <Typography variant="body1" sx={{ color: "#68594F", fontSize: "0.95rem", lineHeight: 1.7 }}>
            Descubre una selección de masajes orientales y relajantes diseñados para aliviar contracturas, reducir el estrés y restaurar tu armonía interior.
          </Typography>
        </Box>

        <Grid container spacing={3.5} sx={{ mb: 4 }}>
          {treatments.map((t) => (
            <Grid item xs={12} sm={6} md={3} key={t.title}>
              <Box
                sx={{
                  backgroundColor: "#FFFFFF",
                  border: "1px solid rgba(158, 119, 54, 0.16)",
                  borderRadius: "20px",
                  overflow: "hidden",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 10px 30px -10px rgba(45, 33, 26, 0.06)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 18px 40px -10px rgba(158, 119, 54, 0.18)",
                    transform: "translateY(-5px)",
                    borderColor: "rgba(158, 119, 54, 0.35)",
                    "& img": {
                      transform: "scale(1.05)",
                    },
                  },
                }}
              >
                <Box sx={{ height: 220, overflow: "hidden", position: "relative" }}>
                  <img
                    src={t.img}
                    alt={t.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                      transition: "transform 0.5s ease",
                    }}
                  />
                </Box>

                <Box sx={{ p: 3, flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", textAlign: "center" }}>
                  <div>
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{
                        mb: 1,
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        color: "#1C1612",
                        fontWeight: 700,
                        fontSize: "1.12rem",
                        letterSpacing: "-0.01em",
                      }}
                    >
                      {t.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        color: "#68594F",
                        fontSize: "0.82rem",
                        lineHeight: 1.5,
                        mb: 2,
                        minHeight: "2.8em",
                      }}
                    >
                      {t.desc}
                    </Typography>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 3 }}>
                      {t.prices.map((p) => (
                        <Box
                          key={p.duration}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: "#FAF8F5",
                            border: "1px solid rgba(158, 119, 54, 0.12)",
                            px: 1.8,
                            py: 0.9,
                            borderRadius: "10px",
                            color: "#4A392F",
                            fontSize: "0.85rem",
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                            <FontAwesomeIcon icon={faClock} size="xs" color="#9E7736" />
                            <span>{p.duration}</span>
                          </Box>
                          <Typography component="span" sx={{ fontWeight: 700, color: "#9E7736", fontSize: "0.92rem" }}>
                            {p.price}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </div>

                  <Button
                    variant="contained"
                    href="https://wa.link/kffk9v"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      background: "linear-gradient(135deg, #DFBA73 0%, #C5A059 50%, #9E7736 100%)",
                      color: "#1C1612",
                      borderRadius: "20px",
                      py: 1.1,
                      fontWeight: 700,
                      fontSize: "0.85rem",
                      textTransform: "none",
                      boxShadow: "0 4px 14px rgba(158, 119, 54, 0.25)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        background: "linear-gradient(135deg, #E6C787 0%, #B89248 50%, #8E6A26 100%)",
                        boxShadow: "0 6px 18px rgba(158, 119, 54, 0.35)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    Reservar Cita →
                  </Button>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ textAlign: "center" }}>
          <Button
            variant="contained"
            size="large"
            href="https://wa.link/kffk9v"
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<FontAwesomeIcon icon={faWhatsapp} />}
            sx={{
              background: "linear-gradient(135deg, #C5A059 0%, #A07A34 100%)",
              color: "#FFFFFF",
              borderRadius: "14px",
              px: 4,
              py: 1.6,
              fontWeight: 700,
              fontSize: "1rem",
              textTransform: "none",
              boxShadow: "0 6px 20px rgba(160, 122, 52, 0.25)",
              "&:hover": {
                background: "linear-gradient(135deg, #B89248 0%, #8E6A26 100%)",
                boxShadow: "0 8px 25px rgba(160, 122, 52, 0.35)",
              },
            }}
          >
            Reservar por WhatsApp
          </Button>
        </Box>
      </Container>
    </section>
  );
};
